import config from 'config';
import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';
import * as termsOfServiceActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/terms-of-service';


export class TOSBanner extends React.Component {
    constructor(props) {
        super(props);
    }

    acceptTermsOfService() {
        mixpanelTracker.track(`${mixpanelTracker.termsOfServiceFooterAcceptanceClicked}`);
        this.props.acceptTermsOfService();
    }

    render() {
        const {t} = this.props;

        return (
            <div className="terms-of-service--container text-center">
                <p>
                    {t('termsOfService.part1')}
                    &nbsp;<a href={config.company.privacyPolicy} target="_blank">{t('termsOfService.part2')}</a> {t('termsOfService.part3')}
                    &nbsp;<a href={config.company.termsOfService} target="_blank">{t('termsOfService.part4')}</a>{t('termsOfService.part5')}
                </p>
                <div>
                    <a onClick={this.acceptTermsOfService.bind(this)} className="btn btn-color-blue">{t('button.ok')}</a>
                </div>
            </div>
        );
    }
}

TOSBanner.propTypes = {
    t: PropTypes.func.isRequired,
    onTermsOfServiceClick: PropTypes.func,
    acceptTermsOfService: PropTypes.func,
};

export default connect(
    null,
    dispatch => bindActionCreators(Object.assign({}, termsOfServiceActions), dispatch)
)(translate(['translation'])(TOSBanner));



// WEBPACK FOOTER //
// ./src/components/SharedComponents/banner/terms-of-service-banner.js